import Record from './base'
import { isPlainObject } from 'lodash'

export class Userticket extends Record {
  constructor(...args) {
    super(...args)
    if (isPlainObject(args[1].ticket_holders)) {
      this.ticket_holders = args[1].ticket_holders[0]
      console.log()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/userticket.js